<template>
  <div class="list-group list-group-horizontal">
    <div
      v-for="link in uniqueLinks"
      :key="link.id"
      class="list-group-item border-0 p-0 bg-transparent"
    >
      <button
        :id="'tooltip-target-' + link.id"
        data-bs-toggle="tooltip"
        :data-bs-placement="'top'"
        :title="
          link.messages.en.tooltip
            ? $tr(link.messages, 'tooltip')
            : $t('widgetAlert.links.tooltip')
        "
        type="button"
        class="btn btn-secondary btn-round btn-sm me-3 d-flex align-items-center"
        @click="didSelectLink(link)"
      >
        {{ $tr(link.messages, 'title') }}
        <i class="ms-2" :class="classesForLinkIcon(link)"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { Tooltip } from 'bootstrap'

export default {
  name: 'AlertLinks',
  props: {
    links: Array,
    groupName: String,
    handleLinkRoute: Function
  },
  computed: {
    uniqueLinks() {
      return this.links.map((l) => {
        // must have either messages.en.href (old style to link to external page)
        // or l.route.name (link via route to anywhere within the app)
        const id = l.messages.en.href || l.route.name
        return { ...l, id }
      })
    }
  },
  methods: {
    classesForLinkIcon(link) {
      const iconClass = link.openInCurrentWindow
        ? 'bi bi-info-circle'
        : `bi ${link.icon ? `bi-${link.icon}` : 'bi-box-arrow-up-right'} fs-5`
      return `${iconClass}`
    },
    didSelectLink(link) {
      if (!link.route) {
        // Add support for opening within application or new window
        const openInCurrentWindow = link.openInCurrentWindow
        const href = this.$tr(link.messages, 'href')
        if (openInCurrentWindow) {
          window.location = href
        } else {
          window.open(href, '_blank')
        }
      } else {
        // Need to hide tooltips manually when clicking on the button since we won't have mouse leave event
        const tooltipEl = document.getElementById('tooltip-target-' + link.id)
        const tooltipInstance = Tooltip.getInstance(tooltipEl)
        if (tooltipInstance) {
          tooltipInstance.hide()
        }
        // Navigate using a route
        const route = {
          ...link.route,
          params: {
            ...link.route.params,
            groupName: this.groupName
          }
        }
        this.handleLinkRoute(route)
      }
    }
  }
}
</script>
